import dayjs from "dayjs";

export const parseDate = (date: string): dayjs.Dayjs => {
  return dayjs(date, "DD-MM-YYYY");
};
